/**
 * @module components\ghTable
 */
import Vue from "vue";
import {
  Component,
  Prop,
  Watch,
  Emit,
  Provide,
  Inject,
  Model
} from "vue-property-decorator";
import VuetifyTable from "./vuetifyTable/vuetifyTable";
import { GhTableBus } from "./IGHTable";

@Component({
  components: { "vuetify-table": VuetifyTable }
})
export default class GhTable extends Vue {
  @Model("change")
  private result: IGhTableSyncProps;

  @Prop()
  props!: IGHTableProps;

  private headers = [];

  @Watch("props.headers")
  private updateHeaders() {
    Object.assign(this.headers, this.props.headers);
    // let json = JSON.stringify(this.props.headers);
    // this.headers = JSON.parse(json);
  }

  private get tableProps() {
    let res = { ...this.props, headers: this.headers };
    return res;
  }

  @Provide()
  syncProps: IGhTableSyncProps = {
    selectedItems: [],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      sortBy: "Id",
      descending: false
    },
    activated: null
  };

  @Provide()
  bus = new GhTableBus();

  private events = [
    "copyItem",
    "editItem",
    "deleteItem",
    "viewItem",
    "moveupItem",
    "movedownItem"
  ];
  private drawer = false;

  created() {
    this.events.forEach(e => {
      this.bus.$on(e, args => {
        this.$emit(e, args);
      });
    });
  }
  destroyed() {
    this.events.forEach(e => {
      this.bus.$destroy();
    });
  }

  mounted() {
    if (this.result) {
      Object.assign(this.syncProps, this.result);
    }
  }

  private search = "";

  private getTemplateName(header: IndexObject) {
    if (header) {
      return "table-cell-" + header.value;
    }
    return "table-cell-Name";
  }
  @Watch("syncProps.pagination", { deep: true })
  private updateResult() {
    this.$emit("change", this.syncProps);
  }

  public showCustom() {
    this.drawer = true;
  }
}
